import sortBy from 'lodash/sortBy';
import type { Package } from 'packages/types';

// The partner's manual order first. Packages without a position, and ties,
// fall back to the name as typed (leading spaces count), then the minimum
// group size, then the id, so the order is always the same. A missing number
// sorts last.
export function sortPackages<PkgType extends Package>(
  pkgs: Array<PkgType>
): Array<PkgType> {
  return sortBy(pkgs, [
    pkg => pkg.position ?? Infinity,
    'name',
    pkg => pkg.capacity.min ?? Infinity,
    'id'
  ]);
}
